export const ProhibitedNotice = () =>
  <>
    <div className='donate-iframe-header'>
      <div className='donate-iframe-headline'>
        <p className='line1'>{I18n.t('donate.prohibited_headline')}</p>
      </div>
    </div>
    <div className='donate-iframe-content'>
      <div className='max-w-screen-xs mx-auto py-6 p-3'>
        {I18n.t('donate.prohibited_notice')}
      </div>
    </div>
  </>
